// extracted by mini-css-extract-plugin
module.exports = {"container":"dm-z"};